// @flow
import * as React from 'react';
import LoadingIndicator from 'components/LoadingIndicator';

import './styles/StreamLoadingIndicator.scss';

class StreamLoadingIndicator extends React.Component<*, *> {
  render() {
    return (
      <div className="StreamLoadingIndicator">
        <LoadingIndicator />
      </div>
    );
  }
}

export default StreamLoadingIndicator;
